import React from "react";
import {ThemeImgUrlType} from "./theme_imgs.ts";
import {IThemeSetting} from "../../common/utils/http/IResponse.ts";

export const ThemeContext = React.createContext({
    theme: {} as IThemeSetting | null,
    loadThemeConfig: () => {
    },
    imgUrls: {} as ThemeImgUrlType,
});